enum BarcodeFormat {
    EAN_13 = 'ean_13',
    EAN_8 = 'ean_8',
    CODE_128 = 'code_128',
    CODE_39 = 'code_39',
    CODE_93 = 'code_93',
    ITF = 'itf',
    UPC_A = 'upc_a',
    UPC_E = 'upc_e'
}

export default BarcodeFormat;
